import Box from '@mui/material/Box';
import Tab, { TabProps } from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useNavigate } from 'react-router-dom';

import colors from '../../constants/colors';
import useAnalytics from '../../hooks/useAnalytics';

function ReusableTab(props: TabProps) {
  return (
    <Tab
      disableRipple
      sx={{
        fontSize: '18px',
        fontWeight: 400,
        color: colors.csaaMid,
        px: { mobile: 3, desktop: 5 },
        py: 2,
        textTransform: 'none',
        '&.Mui-selected': {
          color: colors.csaaBlack,
          fontWeight: 700,
        },
        '&:hover': {
          fontWeight: 600,
          opacity: 1,
        },
      }}
      {...props}
    />
  );
}

interface NavBarProps {
  value: number;
}

export default function NavBar({ value }: NavBarProps) {
  const navigate = useNavigate();
  const { track } = useAnalytics();
  const handleAnalytics = (tab: string) => {
    track(`${tab} Accessed`, {
      event_type: 'Link Accessed',
      link: tab,
      location: 'Header Tab',
    });
  };

  return (
    <Box
      sx={{
        width: 1,
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: '0px 4px 8px rgba(25, 30, 43, 0.08)',
      }}
    >
      <Tabs
        aria-label="Select an overview option"
        value={value}
        sx={{
          color: colors.csaaMid,
          fontFamily: 'RT Raleway',
          fontWeight: 400,
          '& .MuiTabs-flexContainer': {
            justifyContent: {
              mobile: 'space-around',
              desktop: 'center',
            },
          },
          '& .MuiTabs-indicator': {
            backgroundColor: colors.csaaMid,
          },
        }}
        centered
      >
        <ReusableTab
          onClick={() => {
            handleAnalytics('Bills');
            navigate('/bills');
          }}
          label="Bills"
          data-testid="overview-bills-tab"
        />
        <ReusableTab
          onClick={() => {
            handleAnalytics('Policies');
            navigate('/policies');
          }}
          label="Policies"
          data-testid="overview-policies-tab"
        />
        <ReusableTab
          onClick={() => {
            handleAnalytics('Claims');
            navigate('/claims');
          }}
          label="Claims"
          data-testid="overview-claims-tab"
        />
      </Tabs>
    </Box>
  );
}
